'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosVolumeHigh = function IoIosVolumeHigh(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.2 10c2.1 2.8 3.3 6.3 3.3 10s-1.2 7.2-3.3 10l-1.1-0.8c1.9-2.6 3.1-5.8 3.1-9.2s-1.2-6.6-3.1-9.2z m-4.2 17.5l-1.1-0.8c1.4-1.9 2.3-4.2 2.3-6.7s-0.9-4.8-2.3-6.7l1.1-0.8c1.6 2.1 2.5 4.7 2.5 7.5s-0.9 5.4-2.5 7.5z m-3.7-2.5l-1-0.8c0.9-1.2 1.4-2.6 1.4-4.2s-0.5-3-1.4-4.2l1-0.8c1.1 1.4 1.7 3.1 1.7 5s-0.6 3.6-1.7 5z m-9.3-8.1l5.5-4.4v15l-5.5-4.4h-4.5v-6.2h4.5z' })
        )
    );
};

exports.default = IoIosVolumeHigh;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-volume-high.js
// module id = 2553
// module chunks = 0